import type GetAllPositionsDTO from '../../repositories/position/dto/getAll.dto'
import type { PositionRepository } from '../../repositories/position/position.repository'
import type { ChanelActionType, PositionApiWS, PositionWSUpdate } from "@trading/infrastructure";
import type PositionModel from "../../models/position.model";

export default class PositionsController {
  constructor(private positionRepository: PositionRepository, private positionRepositoryWS?: PositionApiWS) {
  }

  async getAllPositions(dto: GetAllPositionsDTO) {
    return await this.positionRepository.getAll(dto)
  }

  async closePosition(id: ID) {
    return await this.positionRepository.closePosition(id)
  }

  async doublePosition(position: PositionModel) {
    return await this.positionRepository.doublePosition(position)
  }

  async reversePosition(position: PositionModel) {
    return await this.positionRepository.reversePosition(position)
  }

  async modifyPosition(position: PositionModel) {
    return await this.positionRepository.modifyPosition(position)
  }

  async subscribeToPositionsChannel(
    actionName: ChanelActionType,
    cb: (order: PositionWSUpdate) => void
  ): Promise<undefined | CallableFunction> {
    if (!this.positionRepositoryWS || typeof this.positionRepositoryWS.subscribeToChannelsAction !== 'function') return
    return await this.positionRepositoryWS.subscribeToChannelsAction(actionName, cb)
  }
}
